import { Injectable, InjectionToken, Inject, Optional } from '@angular/core';

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

export type AnalyticsMode = 'gtm' | 'gtag' | 'both';

export interface AnalyticsConfig {
  mode: AnalyticsMode;            // 'gtm' | 'gtag' | 'both'
  measurementId?: string;         // ej: 'G-FQ7PNN91M1' (solo si usas gtag directo)
  debug?: boolean;                // agrega debug_mode:true automáticamente
  defaultParams?: Record<string, any>; // params comunes a todos los eventos
}

export const ANALYTICS_CONFIG = new InjectionToken<AnalyticsConfig>('ANALYTICS_CONFIG');

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private cfg: AnalyticsConfig = { mode: 'gtm', debug: false };

  constructor(@Optional() @Inject(ANALYTICS_CONFIG) cfg?: AnalyticsConfig) {
    if (cfg) this.cfg = { ...this.cfg, ...cfg };
  }

  setMode(mode: AnalyticsMode) { this.cfg.mode = mode; }

  /** Envío de evento unificado */
  event(name: string, params: Record<string, any> = {}) {
    const payload = {
      ...(this.cfg.defaultParams || {}),
      ...params,
      ...(this.cfg.debug ? { debug_mode: true } : {}),
    };

    // GTM (dataLayer.push)
    if (this.cfg.mode === 'gtm' || this.cfg.mode === 'both') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
    }

    // GA4 directo (gtag)
    if (this.cfg.mode === 'gtag' || this.cfg.mode === 'both') {
      this.ensureGtag();
      const p = this.cfg.measurementId
        ? { send_to: this.cfg.measurementId, ...payload }
        : payload;
      window.gtag!('event', name, p);
    }
  }

  /** Atajos opcionales */
  pageView(path?: string, title?: string) {
    this.event('page_view', {
      page_path: path ?? location.pathname + location.search,
      page_title: title ?? document.title,
    });
  }

  private ensureGtag() {
    if (!window.gtag) {
      // proxy mínimo a dataLayer si no existe gtag; no toca tu HTML
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer!.push(arguments); };
    }
  }
}


